import { IconButton, Typography } from '@amway/react-components';
import {useCallback} from 'react';
import { Card, Image } from 'react-bootstrap';
import { BsCircle } from 'react-icons/bs';
import { useLocation } from 'react-router-dom';
import useAuth from '../../resources/auth/auth-hook';
import { resolveLocationFromState } from '../../utils/location-utils';
import './index.scss';
import {loginRequest} from "../../config/ms-entra-auth";

export default function LoginComponent() {
  const { signIn } = useAuth();
  const location = useLocation();

  const signInWithEntra = useCallback(() => {
    signIn({scopes: loginRequest.scopes, originalUri: resolveLocationFromState(location) });
  },[location, signIn]);
  return (
    <div className="login">
      <Image className="background-image" src="/assets/flat-lay-batch-cooking-assortment.jpg" />
      <Card className="mt-5">
        <Image src="/assets/amway-login-logo.svg" width="149" height="167" />
        <Typography className="mt-3" color="text-black" variant="display">
          Meal Plate Analyser Admin Dashboard
        </Typography>
        <IconButton
          IconComponent={BsCircle}
          color="#FFFFFF"
          size="40px"
          className="okta-login-btn"
          onClick={signInWithEntra}>
          Sign in with Entra
        </IconButton>
      </Card>
    </div>
  );
}
